import { render, staticRenderFns } from "./DxViewWorkOrderProducts.vue?vue&type=template&id=bcf17df2&"
import script from "./DxViewWorkOrderProducts.vue?vue&type=script&lang=js&"
export * from "./DxViewWorkOrderProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports